import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemedImageComponent } from './components/themed-image/themed-image.component';
import { RefuseImageComponent } from './components/refuse-image/refuse-image.component';
import { SaveImageComponent } from './components/save-image/save-image.component';
import { SendImageComponent } from './components/send-image/send-image.component';
import { ErrorImageComponent } from './components/error-image/error-image.component';
import { PuzzleImageComponent } from './components/puzzle-image/puzzle-image.component';
import { SignImageComponent } from './components/sign-image/sign-image.component';
import { DeleteImageComponent } from './components/delete-image/delete-image.component';
import { CheckImageComponent } from './components/check-image/check-image.component';

@NgModule({
  declarations: [
    ThemedImageComponent,
    RefuseImageComponent,
    SaveImageComponent,
    SendImageComponent,
    ErrorImageComponent,
    PuzzleImageComponent,
    SignImageComponent,
    DeleteImageComponent,
    CheckImageComponent,
  ],
  imports: [CommonModule],
  exports: [ThemedImageComponent],
})
export class ThemedImageModule {}
